import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type ArchiveGroupSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function ArchiveGroupSuccessModal({ isOpen, handleClose }: ArchiveGroupSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="archive-group-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.groupArchivedTitle')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="archive-group-success-modal-btn"
      >
        {t('typography.groupArchivedDescription')}
      </AcknowledgeModal>
    </Modal>
  )
}
